//NOT REALLY A MIXIN ^__^
const session_storage_key = 'timeRegistrationWorkSessionKey';

import {CryptoHelper} from "../../classes/CryptoHelper";
import appSettings from "../../mixins/config/appSettings";

export const LocalTimeRegistrationHelper = {
        setCurrentTimeRegistrationWorkSessionIdForUser(hash, user_id) {
            let workSessions = this.getStoredWorkSessions();
            workSessions[user_id] = hash;

            return this.storeWorkSessionObject(workSessions);
        },
        getStoredWorkSessions() {
            let storedWorkSessions = {}

            if (localStorage.getItem(session_storage_key)) {
                try {
                    storedWorkSessions = JSON.parse(localStorage.getItem(session_storage_key));
                } catch (e) {
                    localStorage.removeItem(session_storage_key);
                }
            }

            return storedWorkSessions;
        },
        getCurrentTimeRegistrationWorkSessionIdForUser(user_id){
            let workSessions = this.getStoredWorkSessions();

            if(workSessions[user_id] !== undefined){
                return workSessions[user_id];
            }

            return null;
        },
        getWorkStateStartLockStateForUser(user_id){
            if(this.getCurrentTimeRegistrationWorkSessionIdForUser(user_id)){
                return true;
            }
            return false;
        },
        storeWorkSessionObject(workSessions){
            try {
                localStorage.setItem(session_storage_key, JSON.stringify(workSessions));
                return true;
            } catch (error) {
                return false;
            }
        },
        releaseWorkSessionIdForUser(user_id){
          let workSessions = this.getStoredWorkSessions();
          if(workSessions[user_id] !== undefined){
              workSessions[user_id] = undefined
          }
            return this.storeWorkSessionObject(workSessions);
        },
        generateNewSessionIdForUser(user_id) {
            let crypto = new CryptoHelper()
            let app_id = appSettings.data().appSettings.applicationID;
            let current_time = Math.floor(Date.now() / 1000);
            let chain = user_id + '-' + current_time + '-' + app_id;
            //console.log(chain);
            return crypto.createSHA256FromString(chain);
        }
}